import { render, staticRenderFns } from "./ReportKpis.vue?vue&type=template&id=879c8bde"
import script from "./ReportKpis.vue?vue&type=script&lang=js"
export * from "./ReportKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports